import React from 'react';

const colorMap = {
  primary: 'bg-primary/10 border-primary/20 text-primary',
  accent: 'bg-accent/10 border-accent/20 text-accent',
  success: 'bg-success/10 border-success/20 text-success',
  warning: 'bg-warning/10 border-warning/20 text-warning',
  muted: 'bg-muted/50 border-border text-muted-foreground',
};

const dotColorMap = {
  primary: 'bg-primary',
  accent: 'bg-accent',
  success: 'bg-success',
  warning: 'bg-warning',
  muted: 'bg-muted-foreground',
};

const sizeMap = {
  sm: 'text-xs px-2 py-1',
  md: 'text-sm px-3 py-1.5',
};

function RatingBadge({ label, color = 'primary', size = 'md', showDot = false }) {
  if (!label) return null;

  const textSize = size === 'sm' ? 'text-xs' : 'text-sm';
  const padding = size === 'sm' ? 'px-2.5 py-1' : 'px-3 py-1.5';

  return (
    <div className={`inline-flex items-center gap-1.5 rounded-full ${colorMap[color]} ${textSize} ${padding}`}>
      {showDot && <div className={`h-2 w-2 rounded-full ${dotColorMap[color]}`} />}
      <span className="font-medium">{label}</span>
    </div>
  );
}

export default RatingBadge;
